/**
 * 🎬 Media Types for UI Kit
 * Feature-Sliced Design - Shared Layer
 * 
 * UI Kit에서 사용되는 미디어 관련 타입 정의
 */ /**
 * 업로드된 미디어 파일 타입
 */ /**
 * 미디어 타입 Enum
 */ export var MediaType = /*#__PURE__*/ function(MediaType) {
    MediaType["IMAGE"] = "image";
    MediaType["VIDEO"] = "video";
    MediaType["LINK"] = "link";
    MediaType["UNKNOWN"] = "unknown";
    return MediaType;
}({});
/**
 * 미디어가 비디오인지 확인하는 헬퍼 함수
 */ export function isVideo(media) {
    return media.type === 'video';
}
/**
 * 미디어가 이미지인지 확인하는 헬퍼 함수
 */ export function isImage(media) {
    return media.type === 'image';
}
